<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">合作门店</div>
			<div class="right">
				<el-button size="mini" @click="pageStore(1)">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-content">
			<el-alert style="margin-bottom: 1.25rem;" title="仅支持扫描公众号二维码下单，门店定位坐标20米半径范围内下单的订单，记为该门店提成合作单进行奖励"
				type="warning" show-icon :closable="false">
			</el-alert>
		</div>
		<div class="grid-content-operate">
			<el-button type="primary" size="small" @click="addStore">添加门店</el-button>
			<el-button :disabled="coin_disabled" @click="coinStore" size="small">
				<i class="el-icon-coin"></i>
				<span>增减财务</span>
			</el-button>
		</div>
		<div class="grid-content-list store">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col>
						<col width="12%">
						<col width="10%">
						<col width="20%">
						<col width="9%">
						<col width="16%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>门店信息</th>
							<th>联系手机</th>
							<th>余额</th>
							<th>下单奖励规则</th>
							<th>状态</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col>
						<col width="12%">
						<col width="10%">
						<col width="20%">
						<col width="9%">
						<col width="16%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="10"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox v-model="item.checked" @change="checkboxStore"
											:disabled="item.status==1?false:true"></el-checkbox>
									</div>
								</td>
								<td>
									<div class="shop">
										<div class="icon"><i class="el-icon-s-shop"></i></div>
										<div class="info">
											<div class="box">
												<div class="name">{{item.name}}</div>
												<div class="address">{{item.address}}</div>
											</div>
										</div>
									</div>
								</td>
								<td>
									<div class="phone">{{item.phone}}</div>
								</td>
								<td>
									<div class="amount">
										<div class="num link">{{item.amount}}</div>
										<div class="unit">元</div>
									</div>
								</td>
								<td>
									<div class="reward">
										<div>每笔奖励</div>
										<div class="n">{{item.reward_je}}</div>
										<div>元，加订单总额</div>
										<div class="n">{{item.reward_pa}}</div>
										<div>%</div>
									</div>
								</td>
								<td>
									<div v-if="item.status == 2" class="status fail">
										<i class="el-icon-error"></i>
										<span>停止合作</span>
									</div>
									<div v-else-if="item.status == 1" class="status success">
										<i class="el-icon-success"></i>
										<span>合作中</span>
									</div>
									<div v-else class="status warning">
										<i class="el-icon-warning"></i>
										<span>待审核</span>
									</div>
								</td>
								<td>
									<div v-if="item.status == 2" class="operate">
										<el-button type="success" size="mini" @click="delStore(index, 0)">继续合作
										</el-button>
									</div>
									<div v-else-if="item.status == 1" class="operate">
										<el-button plain size="mini" @click="editStore(index)">编辑</el-button>
										<el-button type="danger" plain size="mini" @click="delStore(index, 1)">停止
										</el-button>
									</div>
									<div v-else class="operate">
										<el-button type="success" plain size="mini">允许合作</el-button>
										<el-button plain size="mini" @click="editStore(index)">编辑</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageStore">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无司机数据" :image-size="100">
			</el-empty>
		</div>
		<el-dialog title="增减财务" :visible.sync="dialog_coin.show" width="35%" append-to-body>
			<el-form :model="dialog_coin.form" size="small">
				<el-form-item label="门店" label-width="60px">
					<span style="font-size: 0.875rem;color: #576b95;">{{dialog_coin.form.name}}</span>
				</el-form-item>
				<el-form-item label="类型" label-width="60px">
					<el-radio-group v-model="dialog_coin.form.type">
						<el-radio-button label="增加"></el-radio-button>
						<el-radio-button label="减少"></el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="金额" label-width="60px">
					<el-input-number v-model="dialog_coin.form.amount" controls-position="right" :min="1" :max="9999"
						:precision="2" :style="{'width':'150px'}">
					</el-input-number>
				</el-form-item>
				<el-form-item label="说明" label-width="60px">
					<el-input v-model="dialog_coin.form.desc" type="textarea" placeholder="请输入金额备注，可为空"
						style="width: 90%;">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialog_coin.show = false">取消</el-button>
				<el-button type="primary" size="small" :loading="dialog_coin.loading" @click="submitCoinStore">确定
				</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择坐标" :visible.sync="dialog_map.show" width="50%">
			<div class="dialog map">
				<div
					:style="{position:'relative',width:'100%',height:'100%',padding:'0 20px 20px','box-sizing': 'border-box'}">
					<el-amap :amap-manager="dialog_map.amapManager" vid="amap" :center="dialog_map.center"
						:zoom="dialog_map.zoom" :zooms="[10,20]">
					</el-amap>
				</div>
				<div class="mark">
					<i class="el-icon-s-shop"></i>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialog_map.show = false">取消</el-button>
				<el-button type="primary" size="small" :loading="dialog_map.loading" @click="submitLocationStore">确定
				</el-button>
			</div>
		</el-dialog>
		<el-drawer :title="drawer_info.form.mode=='edit'?'编辑门店':'添加门店'" :visible.sync="drawer_info.show" size="42%">
			<div class="drawer store">
				<el-alert title="门店区域坐标通常都选为门店中心" type="warning" show-icon :closable="false"></el-alert>
				<div class="content">
					<el-form class="form" :model="drawer_info.form" :rules="drawer_info.rules" label-position="left"
						label-width="100px" ref="storeInfoForm" size="small" style="margin-top: 1.25rem;">
						<el-form-item label="门店名称" prop="name">
							<el-input v-model="drawer_info.form.name" style="width: 12rem;" placeholder="请输入门店名称"
								clearable>
							</el-input>
						</el-form-item>
						<el-form-item label="门店手机" prop="phone">
							<div style="display: inline-block;">
								<el-input v-model="drawer_info.form.phone" style="width: 10rem;" placeholder="请输入手机号码"
									clearable>
								</el-input>
							</div>
							<div class="tips">用于联系和查询门店提成</div>
						</el-form-item>
						<el-form-item label="经纬度">{{drawer_info.form.latitude}}，{{drawer_info.form.longitude}}
						</el-form-item>
						<el-form-item>
							<el-button @click="locationStore(drawer_info.form.latitude,drawer_info.form.longitude)">
								<i class="el-icon-location"></i>
								<span>通过地图选择门店坐标</span>
							</el-button>
						</el-form-item>
						<el-form-item label="门店地址" prop="address">
							<el-input v-model="drawer_info.form.address" placeholder="可通过选择门店坐标自动输入" clearable>
							</el-input>
						</el-form-item>
						<el-divider content-position="left" style="margin: 1.25rem 0;">订单奖励</el-divider>
						<el-form-item label="固定奖励(元)">
							<div style="display: inline-block;">
								<el-input-number v-model="drawer_info.form.reward_je" style="width: 8.125rem;"
									controls-position="right" :min="0" :max="100" :precision="2">
								</el-input-number>
							</div>
							<div class="tips">单笔订单向门店固定奖励费用，0为不奖励</div>
						</el-form-item>
						<el-form-item label="提成奖励(%)">
							<div style="display: inline-block;">
								<el-input-number v-model="drawer_info.form.reward_pa" style="width: 8.125rem;"
									controls-position="right" :min="0" :max="100" :precision="2">
								</el-input-number>
							</div>
							<div class="tips">单笔向门店奖励订单总额百分比，0为不奖励</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" :loading="drawer_info.loading" @click="submitInfoStore">
						{{drawer_info.form.mode == "edit"?"提交保存":"确认添加"}}
					</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import {
		AMapManager,
		lazyAMapApiLoaderInstance
	} from "vue-amap";
	const amapManager = new AMapManager();
	export default {
		data() {
			const self = this;
			return {
				loading: true,
				coin_disabled: true,
				query: {},
				page: 1,
				total: 0,
				list: [],
				location: [],
				dialog_coin: {
					show: false,
					loading: false,
					form: {
						type: '增加',
						name: '',
						amount: 1,
						desc: ''
					}
				},
				drawer_info: {
					show: false,
					loading: false,
					rules: {
						name: [{
							required: true,
							message: '请输入门店名称'
						}],
						phone: [{
								required: true,
								message: '请输入手机号码'
							},
							{
								validator(rule, value, callback) {
									const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
									if (reg.test(value)) {
										callback()
									} else {
										return callback(new Error('请输入正确的手机号码'))
									}
								},
								trigger: 'blur'
							}
						],
						address: [{
							required: true,
							message: '请输入门店地址'
						}]
					},
					form: {
						mode: "add",
						id: 0,
						name: "",
						phone: "",
						address: "",
						latitude: 0,
						longitude: 0,
						reward_je: 0,
						reward_pa: 0
					}
				},
				dialog_map: {
					show: false,
					loading: false,
					amapManager,
					center: [116.397428, 39.909231],
					zoom: 15
				}
			};
		},
		created() {
			this.postStore();
		},
		methods: {
			checkboxStore() {
				const that = this;
				const list = that.list;
				that.coin_disabled = true;
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						that.coin_disabled = false;
						break;
					}
				}
			},
			coinStore() {
				const that = this;
				const list = that.list;
				var name = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						name.push(list[i].name);
					}
				}
				if (name.length <= 0) {
					that.$message.error("请至少选择1个门店");
					return;
				}
				if (name.length > 5) {
					that.$message.error("最多只能选择5个门店");
					return;
				}
				that.dialog_coin = that.$options.data().dialog_coin;
				that.dialog_coin.show = true;
				that.dialog_coin.loading = false;
				that.dialog_coin.form.type = "增加";
				that.dialog_coin.form.name = name.join("、");
			},
			submitCoinStore() {
				const that = this;
				const list = that.list;
				var store = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].checked) {
						store.push(list[i].id);
					}
				}
				that.dialog_coin.loading = true;
				that.$post('marketingStore', {
					mode: "coin",
					type: that.dialog_coin.form.type,
					desc: that.dialog_coin.form.desc,
					store: store,
					amount: that.dialog_coin.form.amount
				}).then(res => {
					that.dialog_coin.show = false;
					that.$message.success("操作成功");
					setTimeout(function() {
						that.pageStore(1);
					}, 1000);
				}).catch(e => {
					that.dialog_coin.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			addStore() {
				const that = this;
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				that.drawer_info.form = that.$options.data().drawer_info.form;
				if (that.$refs.storeInfoForm != undefined) {
					that.$refs.storeInfoForm.resetFields();
				}
			},
			editStore(index) {
				const that = this;
				that.drawer_info.show = true;
				that.drawer_info.loading = false;
				that.$set(that.drawer_info, 'form', {
					mode: "edit",
					id: that.list[index].id,
					name: that.list[index].name,
					phone: that.list[index].phone,
					address: that.list[index].address,
					latitude: that.list[index].location.lat,
					longitude: that.list[index].location.lng,
					reward_je: that.list[index].reward_je,
					reward_pa: that.list[index].reward_pa
				});
				if (that.$refs.storeInfoForm != undefined) {
					that.$refs.storeInfoForm.resetFields();
				}
			},
			submitInfoStore() {
				const that = this;
				that.$refs.storeInfoForm.validate((valid) => {
					if (valid) {
						that.drawer_info.loading = true;
						that.$post('marketingStore', that.drawer_info.form).then(res => {
							that.drawer_info.show = false;
							that.$message.success((that.drawer_info.form.mode == 'edit') ? "编辑成功" :
								"添加成功");
							setTimeout(function() {
								that.pageStore(1);
							}, 1000);
						}).catch(e => {
							that.drawer_info.loading = false;
							that.$alert((e != undefined && e.message != undefined && e.message) ? e
								.message :
								"未知错误，请重试", '提示', {
									type: 'error',
									confirmButtonText: '确定'
								});
						});
					} else {
						return false;
					}
				});
			},
			delStore(index, type) {
				const that = this;
				const ss = (type == 1) ? "停止" : "恢复";
				that.$msgbox({
					title: "提示",
					message: "确定要" + ss + "门店【" + that.list[index].name + "】的合作吗？",
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					beforeClose: (action, instance, done) => {
						if (action === 'confirm') {
							instance.confirmButtonLoading = true;
							instance.confirmButtonText = ss + "中...";
							that.$post('marketingStore', {
								mode: "del",
								store: that.list[index].id
							}).then(res => {
								done();
								that.$message.success("操作成功");
								setTimeout(function() {
									that.pageStore(1);
								}, 1000);
								that.$nextTick(function() {
									instance.confirmButtonLoading = false;
									instance.confirmButtonText = '确定';
								});
							}).catch(e => {
								done();
								that.$nextTick(function() {
									instance.confirmButtonLoading = false;
									instance.confirmButtonText = '确定';
								});
								that.$alert((e != undefined && e.message != undefined && e.message) ? e
									.message :
									"未知错误，请重试", '提示', {
										type: 'error',
										confirmButtonText: '确定'
									});
							});
						} else {
							done();
						}
					}
				}).catch(e => {});
			},
			locationStore(lat, lng) {
				const that = this;
				that.dialog_map.show = true;
				that.dialog_map.loading = false;
				console.log(lat, lng);
				if (lat > 0 || lng > 0) {
					that.dialog_map.zoom = 15;
					that.dialog_map.center = [lng, lat];
				} else {
					that.dialog_map.zoom = that.$options.data().dialog_map.zoom;
					that.dialog_map.center = that.location;
				}
			},
			submitLocationStore() {
				const that = this;
				const map = that.dialog_map.amapManager.getMap();
				that.dialog_map.loading = true;
				that.$post('marketingStore', {
					mode: "location",
					latitude: map.getCenter().lat.toString(),
					longitude: map.getCenter().lng.toString()
				}).then(res => {
					that.dialog_map.show = false;
					that.drawer_info.form.address = res.data.address;
					that.drawer_info.form.latitude = res.data.latitude;
					that.drawer_info.form.longitude = res.data.longitude;
				}).catch(e => {
					that.dialog_map.show = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			pageStore(e) {
				this.page = e;
				this.postStore();
			},
			postStore(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('marketingStore', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							return item;
						});
						that.list = res.data.list;
						that.location = [res.data.lng, res.data.lat];
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.store .shop {
		display: flex;
		padding: 0.5rem 0.625rem;
	}

	.store .shop .icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 3rem;
		height: 3rem;
		border-radius: 50%;
		background-color: #eff6ff;
	}

	.store .shop .icon i {
		color: #6af;
		font-size: 1.75rem;
	}

	.store .shop .info {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.store .shop .info .box {
		margin-left: 0.625rem;
	}

	.store .shop .info .box .name {
		font-size: 1rem;
		font-weight: bold;
	}

	.store .shop .info .box .address {
		display: block;
		color: #999;
		font-size: .768rem;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.store .phone {
		font-size: 0.875rem;
		text-align: center;
	}

	.store .amount {
		display: flex;
		justify-content: center;
		align-items: baseline;
		font-size: 0.875rem;
	}

	.store .reward {
		display: flex;
		justify-content: center;
		align-items: baseline;
		font-size: 0.8125rem;
	}

	.store .reward .n {
		font-weight: bold;
	}

	.store .status {
		text-align: center;
		font-size: 0.8125rem;
	}

	.store .status.warning {
		color: #E6A23C;
	}

	.store .status.success {
		color: #07C160;
	}

	.store .status.fail {
		color: #F56C6C;
	}

	.store .status span {
		font-size: 0.75rem;
		margin-left: 0.125rem;
	}

	.store .operate {
		text-align: center;
	}

	.dialog.map {
		position: relative;
		height: 25rem;
	}

	.dialog.map .mark {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 50%;
		left: 50%;
		width: 1.625rem;
		height: 1.625rem;
		margin-top: -1.625rem;
		margin-left: -0.8125rem;
		border-radius: 50%;
		background-color: black;
	}

	.dialog.map .mark::after {
		position: absolute;
		content: "";
		width: 3px;
		height: 10px;
		bottom: -10px;
		background-color: black;
		border-bottom-left-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.dialog.map .mark i {
		color: white;
		font-size: 1rem;
	}
</style>
